import { SectionIcon } from "@/components/calendars/eventPanelFields.tsx";
import { Sparkle } from "@/components/icons/customIcons.tsx";
import {
  describeOkthxEventAction,
  okthxEventActionQueryOptions,
} from "@/shared/okthxEventAction.ts";
import { useQuery } from "@tanstack/react-query";

/**
 * What okthx last did to this event — "okthx accepted this on Oct 29" — as the
 * event panel's own row (BIG-9318). An RSVP leaves no visible mark on an event
 * someone else organizes, so this row is the only place the user sees it.
 *
 * It owns its whole row, icon included, for the reason `EventBriefSection`
 * does: it renders nothing for the events okthx never touched, and a
 * parent-owned wrapper would leave a bare icon there. The sparkle is the one
 * the brief row leads with, because it names the same thing: okthx did this.
 */
export const EventOkthxActionLine = ({ eventId }: { eventId: string | undefined }) => {
  const { data } = useQuery(okthxEventActionQueryOptions(eventId));
  const okthxAction = data?.okthxAction;
  if (!okthxAction) return null;

  return (
    <div className="flex items-center gap-3">
      <SectionIcon icon={Sparkle} label="What okthx did" />
      <span className="text-sm text-muted-foreground">{describeOkthxEventAction(okthxAction)}</span>
    </div>
  );
};
